<template>
    <div class="row">
        <div v-for="(image, index) in images" :key="index" class="col-3">
            <img v-lazy="getImageUrl(image)" class="mw-100" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    methods: {
        getImageUrl(image) {
            return this.$useWebP ? image.images[0].webP : image.images[0].src;
        }
    }
};
</script>
<style lang="scss" scoped></style>
